import React from 'react';
import moment from 'moment';

export default ({
	EN: {
		updated: `This statement is effective as of ${moment.utc('2020-01-01').format('MMMM D, YYYY')}.`,
		pageTitle: 'Privacy Policy',

		introduction: {
			title: 'Introduction',
			p1: () => (<text>Thank you for your interest in Manheim Mobile Inspections. When we refer to Manheim Mobile Inspections within this Privacy Statement, we
				are referring to Alliance Inspection Management, LLC, and its various subsidiaries, parent company(ies),
				and affiliates, including Alliance Inspection Management Holdings, LLC, Autocomm, Inc., Alliance
				Inspection Management Canada, Inc., or Total Claims Management, LLC
				(collectively, &quot;Manheim Mobile Inspections,&quot; &quot;we,&quot; &quot;our,&quot; or &quot;us&quot;).
				We respect the privacy of our users when they use our websites, mobile and other online applications
				and products and services at Manheim Mobile Inspections’ various websites, including, but not limited
				to, <a href='https://aimdealerinspections.com' target='_blank' rel='noopener noreferrer'>aimdealerinspections.com</a>, <a href='https://homepage.aiminspections.com' target='_blank' rel='noopener noreferrer'>homepage.aiminspections.com</a>,
				and <a href='https://marketconnect.aiminspections.com' target='_blank' rel='noopener noreferrer'>marketconnect.aiminspections.com</a>)
				(collectively, the &quot;Sites&quot;). By using the Sites, you consent to the use of your information and
				information about you in accordance with this Privacy Statement. If you do not agree, do not access
				the Service.</text>),
			p2: 'This Privacy Statement applies to information collected through the Sites and does not ' +
				'describe the collection, use and disclosure practices of any of our corporate affiliates or ' +
				'third parties. For information on the collection, use and disclosure practices of any company with ' +
				'whom you are doing business, whether or not affiliated with Manheim Mobile Inspections, please review their privacy policies.',
			p3: 'Manheim Mobile Inspections is a business-to-business provider of auction and vehicle remarketing services to buyers ' +
				'and sellers of vehicles at wholesale and to their duly authorized agents and representatives. Our Service ' +
				'is not intended for consumers.',
			p4: 'Manheim Mobile Inspections is one of the biggest vehicle inspection companies and collectors of vehicle damage data ' +
				'in North America. These products and services include, but are not limited to, the performance of ' +
				'vehicle inspections, the generation of condition reports, the posting of vehicles on selling platforms ' +
				'and/or storage of vehicle damage data online (collectively referred to as "Services") Services offered ' +
				'by the Sites are not directed to individuals under the age of eighteen (18). If you are under ' +
				'eighteen (18), you should not provide any personal information to us.'
		},

		contents: {
			description: 'This Privacy Statement covers:',
			informationCollected: {
				title: 'Information We Collect',
				description: 'Information is gathered from the Sites by us, our service providers, advertisers, sponsors ' +
					'and partners.',
				provided: {
					title: 'Information You Provide',
					description: 'We may collect information that you choose to provide on the Sites in a variety of ways, ' +
						'such as when you:',
					ol: {
						i1: 'Input data at one of our Site / Register for one of our products or services. ' +
							'This information may include your name, address, telephone number, email address, ' +
							'company name, the last four digits of your social security number or other valid ' +
							'government-issued identification number, such as a driver\'s license, passport or military ID;',
						i2: 'Make information available to us via social networking logins, such as Facebook or Twitter;',
						i3: 'Participate in chats, web forums or other interactive sessions;',
						i4: 'Subscribe to newsletters or provide feedback; and',
						i5: 'Participate in surveys, sweepstakes or other promotions.'
					}
				},
				automated: {
					title: 'Automated Information',
					description: 'Information regarding your use of the Sites may be collected and/or aggregated ' +
						'through the use of automated means. This automatically collected information may include ' +
						'information such as:',
					ol: {
						i1: 'Your IP address, the type of browser and operating system used;',
						i2: 'Date and time you access the Sites and pages you visit, and if you linked ' +
							'from or to another website, the address of that website;',
						i3: 'Email you open and links you click on within those emails; and',
						i4: 'Your ISP or mobile carrier, and the type of handheld or mobile device that you used.'
					}
				},
				dataTechnologies: {
					title: 'Data Technologies',
					p1: 'Various technologies are used to automatically collect information, such as cookies, ' +
						'local shared objects, and web beacons (generally referred to as "Data Technologies.") ' +
						'"Cookies" are small identifiers sent from a web server that are stored on your device for ' +
						'the purpose of identifying your browser or storing information or settings in your browser. ' +
						'"Local shared objects," sometimes known as Flash cookies, may be used to store your ' +
						'preferences or display content based upon what you have viewed on various websites to ' +
						'personalize your visit. A "web beacon," also known as an Internet tag, pixel tag or ' +
						'clear GIF, links web pages to web servers and their cookies. Anonymous advertising ' +
						'identifiers are increasingly being used on mobile devices and otherwise in a manner similar ' +
						'to cookies. When we refer to Data Technologies, we are including all current and similar ' +
						'future technologies.',
					p2: 'One or more Data Technologies may be used on the Sites and other websites and mobile ' +
						'applications (that may not be the Sites) by us, by another party on our behalf, or by ' +
						'third parties in accordance with their privacy policies. Data Technologies may be used by us ' +
						'and others, on our behalf and on their own behalf, to transmit information to you or ' +
						'about you and connect information about you from different sources, websites, devices, and ' +
						'mobile applications.',
					p3: 'We may use a uniquely generated trackable toll-free telephone number on the Sites or ' +
						'in advertisements. If you call one of these uniquely generated toll-free numbers, we ' +
						'(or a service provider acting on our behalf) may collect non-personally identifiable ' +
						'information about the call (e.g. date, time, duration), as well as personally identifiable ' +
						'information (e.g. your name, the number from which your call originated).'
				},
				videos: {
					title: 'Videos',
					description: 'We may target and track the videos you view on the Sites. You consent to our ' +
						'tracking of your video viewing through the Site or third party social media for up to two ' +
						'years or as permitted by applicable law.'
				},
				location: {
					title: 'Location Information',
					description: 'We may collect physical location information that is sufficiently precise to ' +
						'allow us to locate a specific person or device ("Location Information"). We only collect ' +
						'Location Information with your permission (e.g., such as when you agree to provide it to us ' +
						'after initial access to or downloading our website). We may use Location Information and ' +
						'provide it to third parties to provide you with content and services that are relevant to a ' +
						'particular location, such as advertising, search results, auctions in the area, and directions.'
				},
				publiclyPosted: {
					title: 'Publicly Posted Information',
					description: 'Information that you make available to us and others via social media networks, ' +
						'forums, blogs, list serves, chat rooms or similar functionality is public information that ' +
						'we or others may share or use in accordance with the law.'
				},
				combined: {
					title: 'Combined Information and Information from Other Sources',
					description: 'We may combine information that you provide to us with information we receive ' +
						'from our affiliates and other sources, as well as with other information that is ' +
						'automatically collected. The combined information may include information about your use of ' +
						'the Sites, your use of other websites, devices and mobile applications and information ' +
						'from our affiliates and other sources.'
				}
			},

			informationUse: {
				title: 'How We May Use the Information We Collect',
				description: 'We may use information we collect for the following purposes:',
				ol: {
					i1: 'For everyday business purposes, such as establishing and managing your user account, providing ' +
						'products and services you request, and providing customer support;',
					i2: 'To offer our other products or services and/or the products or services of others to you;',
					i3: 'To communicate about, and administer your participation in, special events, programs, surveys, ' +
						'contests, sweepstakes and other offers or promotions;',
					i4: 'To enable you to interact with the Sites and our users, dealers, and others through ' +
						'various means, such as through our message boards, blogs and social media;',
					i5: 'To evaluate and improve our business, including developing new products and services and ' +
						'analyzing the effectiveness of products, services, applications and websites;',
					i6: 'To diagnose and address technical and service problems;',
					i7: 'To perform data analyses, including market and consumer research, trend analysis, ' +
						'demographic analysis and financial analysis;',
					i8: 'To deliver content (including advertising) correlating to your interests and browsing ' +
						'and usage history, both within the Sites and on other websites and applications;',
					i9: 'To comply with applicable legal requirements and our policies; and',
					i10: 'To contact you via telephone, text or chat. We will obtain your consent to contact you when ' +
						'and in the manner required by law.'
				}
			},

			applications: {
				title: 'Applications, Widgets and Social Media',
				description: 'We may include applications or widgets from social media providers that allow ' +
					'interaction or content sharing by their users. These widgets, such as a Facebook "Share" or "Like" ' +
					'button, are visible to you on the web page you visit. Integration between the Sites and social ' +
					'media networks such as Facebook, Twitter and others may allow social media networks in which you ' +
					'participate to collect information about you, even when you do not explicitly activate the ' +
					'network’s application or widget. Please visit the applicable social media network’s privacy policy ' +
					'to better understand their data collection practices and choices they make available to you. ' +
					'The privacy policy of the social media network controls the collection, use and disclosure of ' +
					'all personal information transmitted to that network.'
			},

			advertisingNetworks: {
				title: 'Advertising Networks',
				p1: 'Advertising that is customized based on predictions generated over time from your visits across ' +
					'different websites, devices and mobile applications is sometimes called "online behavioral" or ' +
					'"interest-based" advertising. We may partner with advertising networks, which are companies ' +
					'that deliver targeted advertisements to consumers and generate statistics and metrics related to ' +
					'the delivery of interest-based advertisements. They may utilize information collected through ' +
					'a variety of Data Technologies to provide customization, auditing, research and reporting for us, ' +
					'our affiliates and other advertisers. This data collection takes place both on the Sites and on ' +
					'third-party’s websites and mobile applications. This process allows the Sites and third parties ' +
					'to deliver targeted advertising, enhance marketing programs and help track the effectiveness of ' +
					'such efforts. Our advertising networks also may use this information for determining or ' +
					'predicting the characteristics and preferences of their respective advertising audiences and ' +
					'measuring the effectiveness of their advertising in accordance with their privacy policies.',
				p2: 'We do not provide information that is directly associated with a specific person (such as name ' +
					'and address) to an advertising network when you interact with or view a customized advertisement. ' +
					'However, when you view or interact with an advertisement, the advertiser may make an assumption ' +
					'that you are interested in the subject matter of the advertisement.',
				p3: () => (<text>Some companies disclose when they are using interest-based advertising programs on the Sites to
					deliver third-party ads or collecting information about your visit for these purposes and give you
					the ability to opt-out of this use of your information. You may see an icon in or around
					third-party advertisements on the Sites that use interest-based advertising programs and on pages
					where data is collected and used for online interest-based advertising. Clicking on this icon
					will provide additional information about the companies and data practices that were used to
					deliver the ad. You can opt out of delivery of targeted advertising to you by multiple companies by
					visiting <a href='https://www.aboutads.info/choices' target='_blank' rel='noopener noreferrer'>www.aboutads.info/choices</a> and <a href='https://www.networkadvertising.org/managing/opt_out.asp' target='_blank' rel='noopener noreferrer'>www.networkadvertising.org/managing/opt_out.asp</a>.
					Please note that even if you opt out, you will continue to receive advertisements, but they will
					not be tailored to your specific interests.</text>)
			},

			informationShared: {
				title: 'Information We Share',
				description: 'We do not sell or otherwise share information about you that we collect or receive, ' +
					'except as described below:',
				affiliates: {
					title: 'Affiliates, Dealers, Franchisors and Manufacturers',
					description: () => (<text>Information collected, including personal information and Data Technologies,
						may be shared with affiliates, dealers, franchisors and manufacturers, and their agents and
						third-party service providers, who will use that information in accordance with their own privacy policies. Please
						visit <a href='https://homepage.aiminspections.com' target='_blank' rel='noopener noreferrer'>homepage.aiminspections.com</a> for
						more information about our affiliates.</text>)
				},
				serviceProviders: {
					title: 'Our Service Providers',
					description: 'We may engage third parties to provide the services offered through or in connection ' +
						'with the Sites on our behalf. We require such providers to maintain information about you as ' +
						'confidential and to use the information only to perform the services specified by us in a ' +
						'manner consistent with this Privacy Statement.'
				},
				corporate: {
					title: 'Corporate and Asset Transactions',
					description: 'If we sell all or substantially all of our business or sell or transfer all or a ' +
						'material part of our assets, or are otherwise involved in a merger or transfer of all or a ' +
						'substantial part of our business, we may transfer all information we have collected and ' +
						'stored, including personal information, to the party or parties involved in the transaction ' +
						'as part of that transaction.'
				},
				databases: {
					title: 'Access to Databases',
					description: 'In addition to all of the disclosures described above, we may also allow others to ' +
						'search some of our databases and to analyze the data they find there or aggregate it with ' +
						'other data, either for their business purposes or ours.'
				},
				other: {
					title: 'Other',
					description: 'We may access or disclose information, including personal information, to:',
					ol: {
						i1: 'Protect or defend our interests and the legal rights or property of Manheim Mobile Inspections and our affiliates;',
						i2: 'Protect the rights, interests, safety and security of users of the Sites or ' +
							'members of the public;',
						i3: 'Protect against fraud or for risk management purposes; or',
						i4: 'Comply with prudent legal practice as we may determine, and applicable law or legal process.'
					}
				}
			},

			choices: {
				title: 'Your Choices',
				description: 'You are entitled to make certain choices about how we communicate with you.',
				ol: {
					i1: 'You may choose not to provide personal information, even though that might impact your ability ' +
						'to register or receive a particular product or service.',
					i2: 'If you do not want to receive marketing email from the Sites, you can follow the unsubscribe ' +
						'link provided in those emails.',
					i3: 'If you do not want to receive interest-based advertisements, you can opt out as discussed ' +
						'in the "Advertising Networks" section above.',
					i4: 'You have a number of choices regarding certain Data Technologies. Most web browsers automatically ' +
						'accept cookies, but you can usually modify your browser’s setting to decline cookies if you prefer. ' +
						'You may also render some web beacons unusable by rejecting their associated cookies and disable ' +
						'or delete similar data used by browser add-ons, such as Flash cookies, by changing the add-on\'s ' +
						'settings or the website of the technology provider. If you choose to decline cookies or similar ' +
						'technologies, however, please note that certain features may not function properly or at all ' +
						'as a result. You may be able to adjust the use of advertising identifiers on mobile devices ' +
						'through the settings on your device. Finally, if you do not want to use a uniquely generated ' +
						'telephone number, you may choose to not call us.',
					i5: 'If you do not want us to use Location Information, you can decline our initial invitation ' +
						'to provide that information, or opt out by changing the location services settings on your ' +
						'mobile device. However, please note that certain features may not function properly or at all ' +
						'as a result if you opt out.'
				}
			},

			dataTransfers: {
				title: 'Data Transfers',
				description: 'We may transfer the personal information we collect about you to countries other than ' +
					'the country in which the information originally was collected. Those countries may not have the ' +
					'same data protection laws as the country in which you initially provided the information.'
			},

			access: {
				title: 'Access and Correction',
				description: 'Access to information that we collect and maintain about you may be available to you. ' +
					'For example, if you created a password-protected account within the Sites, you can access that ' +
					'account to update the information you previously provided. Additionally, if you believe that ' +
					'information we maintain about you is inaccurate, subject to applicable law, you may request that ' +
					'we correct or amend the information by contacting us as indicated in the "How to Contact Us" section below.'
			},

			links: {
				title: 'Links',
				description: 'The Sites may contain links to websites not operated by us, as well as third party widgets ' +
					'and applications discussed above. Once you leave the Sites, we suggest that you review the ' +
					'applicable privacy policy of the third-party website or application. We are not responsible ' +
					'for the content or use of any websites or applications other than on the Sites or the privacy ' +
					'practices of those websites or applications.'
			},

			dataSecurity: {
				title: 'Data Security',
				description: 'We use commercially reasonable administrative, technical, personnel, and physical ' +
					'security measures designed to safeguard information about you in our possession against loss, ' +
					'theft and unauthorized use, disclosure or modification. Of course, despite these measures, ' +
					'we cannot guarantee perfect security of networks, servers and databases we operate or that ' +
					'are operated on our behalf.'
			},

			disputes: {
				title: 'Disputes',
				description: 'If you choose to visit the Sites, your visit and any dispute regarding privacy is ' +
					'subject to this Privacy Statement and our Visitor Agreement, including limitations on damages, ' +
					'resolution of disputes, and application of the law of the state of Georgia.'
			},

			updates: {
				title: 'Updates to this Privacy Statement',
				description: 'We may update this Privacy Statement to provide clarification or notice of changes ' +
					'to our practices. If we make changes, we will revise the date at the top of this Privacy Statement. ' +
					'We will provide you with additional notice of material changes by posting notice of the changes ' +
					'for thirty (30) days before we implement those changes.'
			},

			contact: {
				title: 'How to Contact Us',
				description: () => (<text>If you have any questions or comments about this Privacy Statement, or if you
					would like us to update information we have about you or your preferences, please contact us by email
					at <a href='mailto:privacy@coxautoinc.com'>privacy@coxautoinc.com</a>.</text>)
			},

			californiaRights: {
				title: 'Your California Privacy Rights',
				p1: () => (<text>This <strong>Privacy Notice for California Residents</strong> supplements the
					information contained above in Alliance Inspection Management, LLC, and its subsidiaries’
					(collectively referred to as &quot;Manheim Mobile Inspections&quot;) General Privacy Notice and applies solely to all
					visitors, users, and others who reside in the State of California
					(&quot;consumers&quot; or &quot;you&quot;). We adopt this notice to comply with the
					California Consumer Privacy Act of 2018 (CCPA) and any terms defined in the CCPA have the same
					meaning when used in this Notice.</text>),
				p2: () => (<text>Where noted in this Notice, the Privacy Notice does not pertain to personal information
					disclosed in a written or verbal business-to-business communication
					(&quot;<strong>B2B personal information</strong>&quot;).</text>),

				collect: {
					title: 'Information We Collect',
					p1: () => (<text>We collect information that identifies, relates to, describes, references,
						is reasonably capable of being associated with, or could reasonably be linked,
						directly or indirectly, with a particular consumer, household, or device
						(&quot;<strong>personal information</strong>&quot;). Personal information does not include:</text>),
					ul1: {
						i1: 'Publicly available information from government records.',
						i2: 'De-identified or aggregated consumer information.',
						i3: 'Personal information covered by certain sector-specific privacy laws, including the Fair Credit ' +
							'Reporting Act (FCRA), the Gramm-Leach-Bliley Act (GLBA) or California Financial Information ' +
							'Privacy Act (FIPA), and the Driver\'s Privacy Protection Act of 1994.'
					},
					p2: 'In particular, we have collected the following categories of personal information from its ' +
						'consumers within the last twelve (12) months:',
					table: {
						identifiers: {
							category: 'A. Identifiers.',
							examples: 'A real name, alias, postal address, unique personal identifier, online identifier, ' +
								'Internet Protocol address, email address, account name, or other similar identifiers.',
							collected: 'YES'
						},
						personal: {
							category: () => (<text>B. Personal information categories listed in the California Customer
								Records statute (Cal. Civ. Code § 1798.80(e)).<br /><br />(Some personal information included
								in this category may overlap with other categories.)</text>),
							examples1: 'A name, signature, address, telephone number, insurance policy number, ' +
								'or lessee account number.',
							collected1: 'YES',
							examples2: 'Social Security number, physical characteristics or description, passport number, ' +
								'driver\'s license or state identification card number, education, employment, employment history, ' +
								'bank account number, credit card number, debit card number, or any other financial information, ' +
								'medical information, or health insurance information.',
							collected2: 'NO'
						},
						protected: {
							category: 'C. Protected classification characteristics under California or federal law.',
							examples: 'Age (40 years or older), race, color, ancestry, national origin, citizenship, religion ' +
								'or creed, marital status, medical condition, physical or mental disability, sex ' +
								'(including gender, gender identity, gender expression, pregnancy or childbirth and ' +
								'related medical conditions), sexual orientation, veteran or military status, ' +
								'genetic information (including familial genetic information).',
							collected: 'NO'
						},
						commercial: {
							category: 'D. Commercial information.',
							examples: 'Records of personal property, products or services purchased, obtained, ' +
								'or considered, or other purchasing or consuming histories or tendencies.',
							collected: 'YES'
						},
						biometric: {
							category: 'E. Biometric information.',
							examples: 'Genetic, physiological, behavioral, and biological characteristics, or activity ' +
								'patterns used to extract a template or other identifier or identifying information, ' +
								'such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, ' +
								'gait, or other physical patterns, and sleep, health, or exercise data.',
							collected: 'NO'
						},
						internet: {
							category: 'F. Internet or other similar network activity.',
							examples: 'Browsing history, search history, information on a consumer\'s interaction with a ' +
								'website, application, or advertisement',
							collected: 'YES'
						},
						geolocation: {
							category: 'G. Geolocation data.',
							examples: 'Physical location or movements.',
							collected: 'NO'
						},
						sensory: {
							category: 'H. Sensory data.',
							examples: 'Audio, electronic, visual, thermal, olfactory, or similar information.',
							collected: 'NO'
						},
						professional: {
							category: 'I. Professional or employment-related information.',
							examples: 'Current or past job history or performance evaluations.',
							collected: 'NO'
						},
						education: {
							category: 'J. Non-public education information (per the Family Educational Rights and Privacy Act ' +
								'(20 U.S.C. Section 1232g, 34 C.F.R. Part99)).',
							examples: 'Education records directly related to a student maintained by an educational institution ' +
								'or party acting on its behalf, such as grades, transcripts, class lists, student schedules, ' +
								'student identification codes, student financial information, or student disciplinary records.',
							collected: 'NO'
						},
						inferences: {
							category: 'K. Inferences drawn from other personal information.',
							examples: 'Profile reflecting a person\'s preferences, characteristics, psychological trends, ' +
								'predispositions, behavior, attitudes, intelligence, abilities, and aptitudes',
							collected: 'YES'
						}
					},
					p3: 'We obtain the categories of personal information listed above from the following ' +
						'categories of sources:',
					ul2: {
						i1: 'Directly from our customers or their agents. For example, from documents that our clients ' +
							'provide to us related to the services for which they engage us.',
						i2: 'Indirectly from our clients or their agents. For example, through information we collect from ' +
							'our clients in the course of providing services to them.',
						i3: () => (<text>Directly and indirectly from activity on our Sites
							(<a href='https://homepage.aiminspections.com/'>https://homepage.aiminspections.com/</a>; <a href='https://www.aimcertify.com'>https://www.aimcertify.com</a>)
							(collectively referred to as Manheim Mobile Inspections’ &quot;Website&quot;). For example, from submissions through
							our Website portals or Website usage details collected automatically.</text>),
						i4: 'From third-parties that interact with us in connection with the services we perform.'
					}
				},

				use: {
					title: 'Use of Personal Information',
					p1: 'We may use or disclose the personal information we collect for one or more of ' +
						'the following purposes:',
					ul: {
						i1: 'To fulfill or meet the reason you provided the information. For example, if you share ' +
							'your name and contact information to request a price quote or ask a question about our products ' +
							'or services, we will use that personal information to respond to your inquiry. If you provide ' +
							'your personal information to purchase a product or service, we will use that information to ' +
							'process your payment and facilitate delivery. We may also save your information to facilitate ' +
							'new product orders or process returns.',
						i2: 'To provide, support, personalize, and develop our Website, products, and services.',
						i3: 'To create, maintain, customize, and secure your account with us.',
						i4: 'To process your requests, purchases, transactions, and payments and prevent transactional fraud.',
						i5: 'To provide you with support and to respond to your inquiries, including to investigate and ' +
							'address your concerns and monitor and improve our responses.',
						i6: 'To personalize your Website experience and to deliver content and product and service offerings ' +
							'relevant to your interests, including targeted offers and ads through our Website, ' +
							'third-party sites, and via email or text message (with your consent, where required by law).',
						i7: 'To help maintain the safety, security, and integrity of our Website, products and services, ' +
							'databases and other technology assets, and business',
						i8: 'For testing, research, analysis, and product development, including to develop and improve ' +
							'our Website, products, and services.',
						i9: 'To respond to law enforcement requests and as required by applicable law, court order, ' +
							'or governmental regulations.',
						i10: 'As described to you when collecting your personal information or as otherwise set forth in the CCPA.',
						i11: 'To evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, ' +
							'or other sale or transfer of some or all of our assets, whether as a going concern or ' +
							'as part of bankruptcy, liquidation, or similar proceeding, in which personal information ' +
							'held by us about our Website users/consumers is among the assets transferred.'
					},
					p2: 'We will not collect additional categories of personal information or use the ' +
						'personal information we collected for materially different, unrelated, or incompatible purposes ' +
						'without providing you notice.'
				},

				sharing: {
					title: 'Sharing Personal Information',
					description: 'We may disclose your personal information to a third party for a business purpose. ' +
						'When we disclose personal information for a business purpose, we enter a contract ' +
						'that describes the purpose and requires the recipient to both keep that personal information ' +
						'confidential and not use it for any purpose except performing the contract. ' +
						'The CCPA prohibits third parties who receive the personal information we hold from selling it ' +
						'unless you have received explicit notice and an opportunity to opt-out of such sales.',
					p1: 'We share your personal information with the following categories of third parties:',
					ul: {
						i1: 'Our affiliates.',
						i2: 'Service providers.',
						i3: 'Third parties to whom you or your agents authorize us to disclose your personal information ' +
							'in connection with products or services we provide to you.'
					},
					disclosures: {
						title: 'Disclosures of Personal Information for a Business Purpose',
						p1: 'In the preceding twelve (12) months, Company has disclosed the following categories of ' +
							'personal information for a business purpose:',
						ul1: {
							i1: 'Category A: Identifiers.',
							i2: 'Category B: California Customer Records personal information categories.',
							i3: 'Category D: Commercial information.',
							i4: 'Category F: Internet or other similar network activity.',
							i5: 'Category K: Inferences drawn from other personal information.'
						},
						p2: 'We disclose your personal information for a business purpose to the following categories ' +
							'of third parties:',
						ul2: {
							i1: 'Our affiliates.',
							i2: 'Service providers.',
							i3: 'Third parties to whom you or your agents authorize us to disclose your personal information ' +
								'in connection with products or services we provide to you.'
						},
						p3: 'In the preceding twelve (12) months, we have sold the following categories of ' +
							'personal information:',
						ul3: {
							i1: 'In the preceding twelve (12) months, we have not sold any personal information.'
						}
					}
				},

				rights: {
					title: 'Your Rights and Choices',
					description: 'The CCPA provides consumers (California residents) with specific rights regarding ' +
						'their personal information. This section describes your CCPA rights and explains ' +
						'how to exercise those rights.',
					access: {
						title: 'Access to Specific Information and Data Portability Rights',
						description: 'You have the right to request that we disclose certain information to you ' +
							'about our collection and use of your personal information over the past 12 months. ' +
							'Once we receive and confirm your verifiable consumer request (see Exercising Access, ' +
							'Data Portability, and Deletion Rights), we will disclose to you:',
						ul: {
							i1: 'The categories of personal information we collected about you.',
							i2: 'The categories of sources for the personal information we collected about you.',
							i3: 'Our business or commercial purpose for collecting or selling that personal information.',
							i4: 'The categories of third parties with whom we share that personal information.',
							i5: 'The specific pieces of personal information we collected about you (also called ' +
								'a data portability request).',
							i6: 'If we sold or disclosed your personal information for a  business purpose, ' +
								'two separate lists disclosing:',
							ul: {
								i1: 'sales, identifying the personal information categories that each category of ' +
									'recipient purchased; and',
								i2: 'disclosures for a business purpose, identifying the personal information categories ' +
									'that each category of recipient obtained.'
							}
						},
						p1: 'We do not provide these access and data portability rights for B2B personal information.'
					},
					deletion: {
						title: 'Deletion Request Rights',
						description: 'You have the right to request that we delete any of your personal information ' +
							'that we collected from you and retained, subject to certain exceptions. Once we receive and ' +
							'confirm your verifiable consumer request (see Exercising Access, Data Portability, ' +
							'and Deletion Rights), we will delete (and direct our service providers to delete) ' +
							'your personal information from our records, unless an exception applies.',
						p1: 'We may deny your deletion request if retaining the information is necessary for us or ' +
							'our service provider(s) to:',
						ol: {
							i1: 'Complete the transaction for which we collected the personal information, provide ' +
								'a good or service that you requested, take actions reasonably anticipated within ' +
								'the context of our ongoing business relationship with you, fulfill the terms of ' +
								'a written warranty or product recall conducted in accordance with federal law, ' +
								'or otherwise perform our contract with you.',
							i2: 'Detect security incidents, protect against malicious, deceptive, fraudulent, or ' +
								'illegal activity, or prosecute those responsible for such activities.',
							i3: 'Debug products to identify and repair errors that impair existing intended functionality.',
							i4: 'Exercise free speech ensure the right of another consumer to exercise ' +
								'their free speech rights, or exercise another right provided for by law.',
							i5: () => (<text>Comply with the California Electronic Communications Privacy Act
								(Cal. Penal Code § 1546 <em>et. seq.</em>).</text>),
							i6: 'Engage in public or peer-reviewed scientific, historical, or statistical research ' +
								'in the public interest that adheres to all other applicable ethics and privacy laws, ' +
								'when the information\'s deletion may likely render impossible or seriously impair ' +
								'the research\'s achievement, if you previously provided informed consent.',
							i7: 'Enable solely internal uses that are reasonably aligned with consumer expectations based ' +
								'on your relationship with us.',
							i8: 'Comply with a legal obligation.',
							i9: 'Make other internal and lawful uses of that information that are compatible with ' +
								'the context in which you provided it.'
						},
						p2: 'We do not provide these deletion rights for B2B personal information.'
					},
					exercising: {
						title: 'Exercising Access, Data Portability, and Deletion Rights',
						p1: 'To exercise the access, data portability, and deletion rights described above, ' +
							'please submit a verifiable consumer request to us by either:',
						ul1: {
							i1: 'Calling us at 1-833-430-0054.',
							i2: () => (<text>Emailing us at <a href='mailto:privacy@coxautoinc.com'>privacy@coxautoinc.com</a>.</text>)
						},
						p2: 'Only you, or someone legally authorized to act on your behalf, may make a verifiable ' +
							'consumer request related to your personal information. You may also make a verifiable ' +
							'consumer request on behalf of your minor child.',
						p3: 'You may only make a verifiable consumer request for access or data portability twice within ' +
							'a 12-month period. The verifiable consumer request must:',
						ul2: {
							i1: 'Provide sufficient information that allows us to reasonably verify you are the person ' +
								'about whom we collected personal information or an authorized representative; and',
							i2: 'Describe your request with sufficient detail that allows us to properly understand, ' +
								'evaluate, and respond to it.',
							i3: 'For leasee’s using our services for lease-end inspections, please make all access, ' +
								'data portability, and deletion inquiries/requests through your respective lessor, ' +
								'as we are merely providing them a service to you per the lessor’s request.'
						},
						p4: 'We cannot respond to your request or provide you with personal information if we cannot ' +
							'verify your identity or authority to make the request and confirm the ' +
							'personal information relates to you.',
						p5: 'We cannot respond to your request or provide you with personal information if we cannot ' +
							'verify your identity or authority to make the request and confirm the personal information ' +
							'relates to you. Making a verifiable consumer request does not require you to create an ' +
							'account with us.However, we do consider requests made through your password protected ' +
							'account sufficientlyverified when the request relates to personal information associated ' +
							'with that specific account',
						p6: 'We will only use personal information provided in a verifiable consumer request to verify ' +
							'the requestor\'s identity or authority to make the request.'
					},
					response: {
						title: 'Response Timing and Format',
						p1: 'We endeavor to respond to a verifiable consumer request within forty-five (45) days of ' +
							'its receipt. If we require more time (up to 45 days), we will inform you of the reason and ' +
							'extension period in writing.',
						p2: 'If you have an account with us, we will deliver our written response to that account. ' +
							'If you do not have an account with us, we will deliver our written response by mail or ' +
							'electronically, at your option.',
						p3: 'Any disclosures we provide will only cover the 12-month period preceding the verifiable ' +
							'consumer request\'s receipt. The response we provide will also explain the reasons we ' +
							'cannot comply with a request, if applicable. For data portability requests, we will select ' +
							'a format to provide your personal information that is readily useable and should allow you ' +
							'to transmit the information from one entity to another entity without hindrance.',
						p4: 'We do not charge a fee to process or respond to your verifiable consumer request unless ' +
							'it is excessive, repetitive, or manifestly unfounded. If we determine that the request ' +
							'warrants a fee, we will tell you why we made that decision and provide you with a ' +
							'cost estimate before completing your request.'
					}
				},

				nonDiscrimination: {
					title: 'Non-Discrimination',
					p1: 'We will not discriminate against you for exercising any of your CCPA rights. Unless permitted ' +
						'by the CCPA, we will not:',
					ul: {
						i1: 'Deny you goods or services.',
						i2: 'Charge you different prices or rates for goods or services, including through granting ' +
							'discounts or other benefits, or imposing penalties.',
						i3: 'Provide you a different level or quality of goods or services.',
						i4: 'Suggest that you may receive a different price or rate for goods or services or a different ' +
							'level or quality of goods or services.'
					},
					p2: 'However, we may offer you certain financial incentives permitted by the CCPA that can ' +
						'result in different prices, rates, or quality levels. Any CCPA-permitted financial incentive ' +
						'we offer will reasonably relate to your personal information\'s value and contain written terms ' +
						'that describe the program\'s material aspects. Participation in a financial incentive program ' +
						'requires your prior opt in consent, which you may revoke at any time. ' +
						'We currently do not provide any financial incentives.'
				},

				other: {
					title: 'Other California Privacy Rights',
					description: () => (<text>California’s &quot;Shine the Light&quot; law (Civil Code Section § 1798.83)
						permits users of our Website that are California residents to request certain information
						regarding our disclosure of personal information to third parties for their direct
						marketing purposes. To make such a request, please send an email
						to <a href='mailto:privacy@coxautoinc.com'>privacy@coxautoinc.com</a> or
						write us at: Cox Automotive, Inc., Attn: Cox Automotive Privacy Operations Team, 6205 Peachtree Dunwoody Road NE, Atlanta, GA 30328.</text>)
				},

				changes: {
					title: 'Changes to Our Privacy Notice',
					description: () => (<text>We reserve the right to amend this privacy notice at our discretion
						and at any time. When we make changes to this privacy notice, we will post the updated notice
						on the Website and update the notice’s effective date. <strong>Your continued use of our Website
							following the posting of changes constitutes your acceptance of such changes.</strong></text>)
				},

				contact: {
					title: 'Contact Information',
					description: () => (<text>If you have any questions or comments about this notice, the ways
						in which Manheim Mobile Inspections collects and uses your information described here and in the <strong>Privacy Policy</strong>,
						your choices and rights regarding such use, or wish to exercise your rights under California law,
						please do not hesitate to contact us at:</text>),
					ul: {
						i1: () => (<text><strong>Phone:</strong> 1-833-430-0054</text>),
						i2: () => (<text><strong>Website:</strong> <a href='https://homepage.aiminspections.com'>homepage.aiminspections.com</a></text>),
						i3: () => (<text><strong>Email:</strong> <a href='mailto:privacy@coxautoinc.com'>privacy@coxautoinc.com</a></text>),
						i4: () => (
							<text>
								<strong>Postal Address:</strong><br />
								Cox Automotive, Inc.<br />
								Attn: Cox Automotive Privacy Operations Team<br />
								6205 Peachtree Dunwoody Road NE<br />
								Atlanta, GA 30328
							</text>
						)
					}
				}
			}
		}
	}
});
